import { BaseModel } from 'src/app/shared/models/base.model';

export const MapPhoneFields = {
  number: 'Número',
  phone_type: 'Tipo do Telefone',
  primary: 'Primário',
  send_notification: 'Enviar notificação',
  obs: 'Observações',
  deleted: '',
  whatsapp: 'Whatsapp',
};

export class Phone extends BaseModel {
  number: string;
  phone_type: string;
  primary: boolean;
  send_notification: boolean;
  obs: string;
  deleted: boolean;
  whatsapp: boolean;

  constructor() {
    super();

    this.phone_type = 'C';
    this.primary = false;
    this.send_notification = true;
    this.deleted = false;
    this.whatsapp = false;
  }

  static fromJson(jsonData: any): Phone {
    return Object.assign(new Phone(), jsonData);
  }

  getMapFields() {
    return MapPhoneFields;
  }
}



